import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { CloseIcon } from '@seedlang/icons';
import { isPresent } from '@seedlang/utils';
import Button from 'components/button/button';
import { BannerNoticesShowWrapper } from '@seedlang/hoc';

const Wrapper = styled.div`
  background: #FFF;
  border-radius: 10px;
  padding: 20px;
  margin: ${props => props.margin};
  position: relative;

  a {
    text-decoration: underline;
  }
`;

const CloseIconWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 0px;
  svg {
    fill: #333;
    width: 16px;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  a {
    color: #FFF;
  }
`;

@observer
class BannerNoticeShow extends React.Component {

  render() {
    if (!this.props.hide) {
      return (
        <Wrapper
          margin={AppUI.layout.isMobile ? '10px 10px 0 10px' : '10px 0'}
        >
          {
            this.props.bannerNotice.dismissible && (
              <CloseIconWrapper onClick={this.props.onHide}>
                <CloseIcon />
              </CloseIconWrapper>
            )
          }
          <div dangerouslySetInnerHTML={{ __html: this.props.bannerNotice.text }} />
          {
            isPresent(this.props.bannerNotice?.buttonText) && isPresent(this.props.bannerNotice?.url) &&
            <ButtonRow>
              <Button
                background={AppUI.site.accentColor}
                scaleOnHover={1.01}
                scaleOnActive={0.99}
                onClick={this.props.onButtonClick}
              >
                {this.props.bannerNotice?.buttonText}
              </Button>
            </ButtonRow>
          }
        </Wrapper>
      );
    } else {
      return <div />;
    }
  }
}

export default BannerNoticesShowWrapper(BannerNoticeShow);
